import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-305ffa58"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "ticket-item"
};
const _hoisted_2 = {
  class: "order-id-box"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));

const _hoisted_4 = {
  class: "ticket-info"
};
const _hoisted_5 = {
  class: "left-part"
};
const _hoisted_6 = {
  class: "price-box"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "color-block color-block-1"
}, null, -1));

const _hoisted_8 = {
  class: "price-text"
};
const _hoisted_9 = {
  class: "price-number"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "price-tag"
}, "RMB", -1));

const _hoisted_11 = {
  class: "tickeks-title"
};
const _hoisted_12 = {
  class: "right-part"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 0,
  class: "use-date-text"
};
const _hoisted_15 = {
  class: "order-conut"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tickeks-tips"
}, "商品数量", -1));

const _hoisted_17 = {
  key: 0
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "know-info"
}, [/*#__PURE__*/_createTextVNode("入场时，请向工作人员出示该二维码，"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("即可兑换相应数量入场凭证")], -1));

const _hoisted_19 = {
  class: "qrcode-box"
};
const _hoisted_20 = ["src"];

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qrcode-tip-text"
}, "长按可保存或分享票券二维码", -1));

const _hoisted_22 = {
  class: "ticekt-price-info-box"
};
const _hoisted_23 = {
  class: "key-val-box-2-column"
};

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key-text"
}, "票品总价", -1));

const _hoisted_25 = {
  class: "val-text"
};
const _hoisted_26 = {
  key: 0,
  class: "key-val-box-2-column"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key-text"
}, "第二件半价", -1));

const _hoisted_28 = {
  class: "val-text"
};
const _hoisted_29 = {
  key: 1,
  class: "key-val-box-2-column"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key-text"
}, "优惠码", -1));

const _hoisted_31 = {
  class: "val-text"
};
const _hoisted_32 = {
  class: "key-val-box-2-column important-text"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "key-text"
}, "订单合计", -1));

const _hoisted_34 = {
  class: "val-text"
};
const _hoisted_35 = {
  key: 2,
  class: "payment-info-box"
};

const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"payment-info\" data-v-305ffa58><div class=\"title\" data-v-305ffa58>支付方式</div><div class=\"payment-detail\" data-v-305ffa58><div class=\"circle-outside\" data-v-305ffa58><div class=\"circle-inside\" data-v-305ffa58></div></div><div class=\"wx-pay-text\" data-v-305ffa58>微信支付</div></div></div><div class=\"payment-info-tip\" data-v-305ffa58>票品售出，除因不可抗力因素导致大会延期或取消，其他不支持退改</div>", 2);

const _hoisted_38 = [_hoisted_36];
const _hoisted_39 = {
  class: "ticket-other-info-box"
};
const _hoisted_40 = {
  class: "key-val-box-1-column"
};
const _hoisted_41 = {
  class: "key-text"
};
const _hoisted_42 = {
  class: "val-text"
};
const _hoisted_43 = {
  class: "key-val-box-1-column"
};

const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "key-text"
}, "创建时间：", -1));

const _hoisted_45 = {
  class: "val-text"
};
const _hoisted_46 = {
  key: 0,
  class: "key-val-box-1-column"
};

const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "key-text"
}, "支付时间：", -1));

const _hoisted_48 = {
  class: "val-text"
};
const _hoisted_49 = {
  key: 1,
  class: "key-val-box-1-column"
};

const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "key-text"
}, "微信商户订单号：", -1));

const _hoisted_51 = {
  class: "val-text"
};
const _hoisted_52 = {
  key: 2,
  class: "key-val-box-1-column"
};

const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "key-text"
}, "微信支付单号：", -1));

const _hoisted_54 = {
  class: "val-text"
};

const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-tip"
}, "扫描下方二维码完成支付", -1));

const _hoisted_56 = {
  class: "share-img-wrapper"
};
const _hoisted_57 = ["src"];
const _hoisted_58 = {
  class: "logout-wrapper"
};

const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logout-tip-text"
}, "请返回上一支付场景完成支付，或重新下单", -1));

const _hoisted_60 = {
  class: "btn-box"
};
const _hoisted_61 = {
  key: 2,
  class: "go-to-buy-bar"
};
const _hoisted_62 = {
  class: "left-price-part"
};
const _hoisted_63 = {
  class: "price-text"
};
const _hoisted_64 = {
  class: "price-tip-text"
};
const _hoisted_65 = {
  key: 3,
  class: "go-to-buy-bar"
};

const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-price-part"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "price-text"
}, "订单已关闭")], -1));

import { useRoute } from "vue-router";
import { ref, onBeforeMount } from "vue";
import { Dialog, Toast } from "vant";
import TopNavigator from "../components/TopNavigator.vue";
import { initWxJssdk, encodeRSA, browserType, date2ISO } from "../assets/utils/common.utils";
import router from "../router";
import AV from "../assets/utils/av";
import request from "../assets/utils/request";
import { nftShopApi, payTypeEunm, SALTSTR } from "../common.config";
import wx from "weixin-js-sdk";
import CommonBtn from "../components/CommonBtn.vue";
import dayjs from "dayjs";
export default {
  __name: 'UserOrderDetail',
  props: {},

  setup(__props) {
    const props = __props;
    const VanDialog = Dialog.Component;
    const curRouter = useRoute();
    onBeforeMount(() => {
      fetch();
    });
    const order = ref(null);

    const fetch = () => {
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      const query = curRouter.query;
      const orderId = query.orderId;
      request.get(`${nftShopApi}/order/info/${orderId}`).then(res => {
        if (res.code == 200) {
          var _order$value, _order$value2, _order$value3, _order$value4, _order$value4$ticketC, _order$value5, _order$value5$ticketC;

          order.value = res.data;
          order.value.priceStr = Number(order.value.price) / 100;
          order.value.priceTotal = (order.value.price * order.value.quantity / 100).toFixed(2);
          order.value.totalFeeStr = order.value.isRedeem ? "0.00" : (order.value.totalFee / 100).toFixed(2);
          order.value.halfPriceStr = order.value.halfPrice && (order.value.halfPrice / 100).toFixed(2);
          order.value.proPriceStr = order.value.proPrice && (order.value.proPrice / 100).toFixed(2);
          order.value.createAtStr = dayjs(date2ISO(order.value.createdAt)).format("YYYY.MM.DD HH:mm:ss");
          order.value.expiresAtStr = ((_order$value = order.value) === null || _order$value === void 0 ? void 0 : _order$value.expiresAt) && dayjs(date2ISO((_order$value2 = order.value) === null || _order$value2 === void 0 ? void 0 : _order$value2.expiresAt)).format("YYYY.MM.DD HH:mm:ss");
          order.value.payTimeStr = ((_order$value3 = order.value) === null || _order$value3 === void 0 ? void 0 : _order$value3.payTime) && dayjs(date2ISO(order.value.payTime)).format("YYYY.MM.DD HH:mm:ss");

          if ((_order$value4 = order.value) !== null && _order$value4 !== void 0 && (_order$value4$ticketC = _order$value4.ticketCatInfo) !== null && _order$value4$ticketC !== void 0 && _order$value4$ticketC.days && ((_order$value5 = order.value) === null || _order$value5 === void 0 ? void 0 : (_order$value5$ticketC = _order$value5.ticketCatInfo) === null || _order$value5$ticketC === void 0 ? void 0 : _order$value5$ticketC.days.length) > 0) {
            var _order$value6, _order$value6$ticketC;

            const days = (_order$value6 = order.value) === null || _order$value6 === void 0 ? void 0 : (_order$value6$ticketC = _order$value6.ticketCatInfo) === null || _order$value6$ticketC === void 0 ? void 0 : _order$value6$ticketC.days;
            const len = days.length;
            order.value.usefulDuration = [];

            if (len === 1) {
              const arrDays = days[0].split("T");
              order.value.usefulDuration.push("2022." + arrDays[0] + " " + (arrDays[1] || ""));
            } else {
              days.forEach(day => {
                const arrDays = day.split("T");
                order.value.usefulDuration.push("2022." + arrDays[0] + " " + (arrDays[1] || ""));
              });
            }
          } // pending paid finished closed
          // order.value.status = "finished";


          Toast.clear();
        } else {
          Toast.fail("加载失败");
        }
      }).catch(err => {
        Toast.clear();
        console.error("获取订单：", err);
      });
    }; //支付异常弹窗关闭


    const onClosePayDialog = () => {};

    const showPayErrorDialog = ref(false);

    const closeErrorDialog = () => {
      showPayErrorDialog.value = false;
    }; // 直接支付


    const handleBuy = orderInfo => {
      var _curUser$authData, _curUser$authData$wei;

      // 直接支付
      const curUser = AV.User.current() && AV.User.current().toJSON();
      const openid = curUser === null || curUser === void 0 ? void 0 : (_curUser$authData = curUser.authData) === null || _curUser$authData === void 0 ? void 0 : (_curUser$authData$wei = _curUser$authData.weixin) === null || _curUser$authData$wei === void 0 ? void 0 : _curUser$authData$wei.openid;
      const orderPayType = orderInfo.payType;
      let payType = payTypeEunm.JSAPI;

      if (browserType.versions.wx) {
        payType = payTypeEunm.JSAPI;
      } else if (browserType.versions.mobile || browserType.versions.ios || browserType.versions.android || browserType.versions.iPhone || browserType.versions.iPad) {
        payType = payTypeEunm.H5;
      } else {
        payType = payTypeEunm.NATIVE;
      } // 支付场景异常


      if (payType != orderPayType) {
        showPayErrorDialog.value = true;
        return;
      } else {
        var _orderInfo$ticketCatI;

        // 发起支付操作
        Toast.loading({
          message: "发起支付...",
          forbidClick: true
        }); // 非标准iso无法识别

        const createdAtFormat = date2ISO(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.createdAt);
        const expiresAtFormat = date2ISO(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.expiresAt);
        const salt = `${orderInfo.totalFee}_${createdAtFormat}_${SALTSTR}`;
        const enTotalFeeKey = encodeRSA(salt);
        const prepayParams = {
          pay_type: payType,
          description: orderInfo === null || orderInfo === void 0 ? void 0 : (_orderInfo$ticketCatI = orderInfo.ticketCatInfo) === null || _orderInfo$ticketCatI === void 0 ? void 0 : _orderInfo$ticketCatI.name,
          order_id: orderInfo.objectId,
          total_fee: orderInfo.totalFee,
          openid: openid,
          time_expire: expiresAtFormat,
          created_at: createdAtFormat,
          total_fee_key: enTotalFeeKey
        };
        request.post(`${nftShopApi}/pay/wechat_pay`, prepayParams).then(wechatPayRes => {
          if (wechatPayRes.code == 200) {
            if (payType == payTypeEunm.JSAPI) {
              // JSAPI - 微信环境使用==================================
              const {
                appid,
                timestamp,
                noncestr,
                package: wxPackage,
                signType,
                paySign,
                prepay_id
              } = wechatPayRes.data;
              const order = AV.Object.createWithoutData("Order", orderInfo.objectId);
              order.set("prepay_id", prepay_id);
              order.save().then(res => {
                initWxJssdk(() => {
                  wx.chooseWXPay({
                    timestamp: timestamp,
                    nonceStr: noncestr,
                    // 支付签名随机串，不长于 32 位
                    package: wxPackage,
                    // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    signType: signType,
                    // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                    paySign: paySign,
                    // 支付签名
                    success: function (res) {
                      // 支付成功后的回调函数,检查支付状态
                      router.replace({
                        path: "/check-pay-status",
                        query: {
                          orderId: orderInfo.objectId
                        }
                      });
                    },
                    fail: err => {
                      Toast.fail("支付失败");
                      router.replace("/user-orders");
                    },
                    cancel: function (err) {
                      // 用户取消支付
                      Toast.fail("取消支付");
                      router.replace("/user-orders");
                    }
                  });
                });
              }).catch(err => {
                Toast.fail("发起支付失败！");
                router.replace("/user-orders");
                console.error("保存prepay_id: ", err);
              });
            } else if (payType == payTypeEunm.H5) {
              // H5 - 移动端浏览器且非微信浏览器==================================
              const {
                h5_url,
                order_id
              } = wechatPayRes === null || wechatPayRes === void 0 ? void 0 : wechatPayRes.data;

              if (h5_url && order_id) {
                const h5RedirectUri = encodeURIComponent(`${window.location.origin}/check-pay-status?orderId=${order_id}`);
                window.location.href = `${h5_url}&redirect_url=${h5RedirectUri}`;
              } else {
                Toast.fail("发起支付失败");
                router.replace("/user-orders");
              }
            } else {
              // NATIVE - PC端==================================
              const {
                order_id,
                qrcode_url
              } = wechatPayRes === null || wechatPayRes === void 0 ? void 0 : wechatPayRes.data;

              if (order_id && qrcode_url) {
                payQrcode.value = qrcode_url;
                createdOrderId.value = order_id;
                handleNativePay();
              } else {
                Toast.fail("支付二维码\n生成失败");
                router.replace("/user-orders");
              }
            }
          } else if (wechatPayRes.code != 200 && wechatPayRes.data) {
            // wechatPayRes.code == 1002 订单金额解密失败
            Toast.fail(wechatPayRes.data);
          } else {
            Toast.fail("发起支付失败");
            router.replace("/user-orders");
          }
        }).catch(err => {
          Toast.fail("发起支付错误");
          router.replace("/user-orders");
          console.error("发起支付：", err);
        });
      }
    }; // native支付回调处理


    const timer1 = ref(null);
    const showDialog = ref(false);
    const payQrcode = ref("");
    const createdOrderId = ref("");

    const handleNativePay = () => {
      if (!showDialog.value) {
        showDialog.value = true;
      }

      request(`${nftShopApi}/order/info/${createdOrderId.value}`).then(res => {
        const {
          status
        } = res === null || res === void 0 ? void 0 : res.data;

        if (status === "paid") {
          // 支付成功跳转支付广告页
          clearTimeout(timer1.value);
          router.replace({
            path: "/add-grounp-buy",
            query: {
              orderId: createdOrderId.value
            }
          });
        } else {
          timer1.value = setTimeout(() => {
            handleNativePay();
          }, 1500);
        }
      }).catch(err => {
        showDialog.value = false;
        clearTimeout(timer1.value);
        Toast.fail("订单查询错误");
        console.error("获取订单详情：", err);
      });
    }; // 关闭分享弹窗回调


    const onCloseShareDialog = () => {
      clearTimeout(timer1.value);
      payQrcode.value = "";
      createdOrderId.value = "";
      Toast.fail("取消支付");
      router.replace("/user-orders");
    }; // 再次购买


    const handleBuyMore = () => {
      router.push("/buy");
    };

    return (_ctx, _cache) => {
      var _order$value7, _order$value8, _order$value9, _order$value10, _order$value11, _order$value11$ticket, _order$value12, _order$value12$ticket, _order$value13, _order$value14, _order$value15, _order$value16, _order$value17, _order$value18, _order$value19, _order$value20, _order$value21, _order$value22, _order$value23, _order$value24, _order$value25, _order$value26, _order$value27, _order$value28, _order$value29, _order$value30, _order$value31, _order$value32;

      return _openBlock(), _createElementBlock(_Fragment, null, [((_order$value7 = order.value) === null || _order$value7 === void 0 ? void 0 : _order$value7.status) == 'paid' ? (_openBlock(), _createBlock(TopNavigator, {
        key: 0,
        title: "订单详情",
        rightComponent: "refresh"
      })) : (_openBlock(), _createBlock(TopNavigator, {
        key: 1,
        title: "订单详情"
      })), _createElementVNode("div", {
        class: _normalizeClass(['user-order-detail-page-root', 'scroll-bar-style', ((_order$value8 = order.value) === null || _order$value8 === void 0 ? void 0 : _order$value8.status) == 'pending' || ((_order$value9 = order.value) === null || _order$value9 === void 0 ? void 0 : _order$value9.status) == 'closed' ? 'has-pay-bar' : ''])
      }, [order.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(order.value.isRedeem ? "兑换" : "订单") + "编号：" + _toDisplayString(order.value.objectId), 1), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString((_order$value10 = order.value) === null || _order$value10 === void 0 ? void 0 : _order$value10.priceStr), 1), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString((_order$value11 = order.value) === null || _order$value11 === void 0 ? void 0 : (_order$value11$ticket = _order$value11.ticketCatInfo) === null || _order$value11$ticket === void 0 ? void 0 : _order$value11$ticket.name) + "·极客公园创新大会2023", 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
        class: "ticket-cover-img",
        src: (_order$value12 = order.value) === null || _order$value12 === void 0 ? void 0 : (_order$value12$ticket = _order$value12.ticketCatInfo) === null || _order$value12$ticket === void 0 ? void 0 : _order$value12$ticket.cover
      }, null, 8, _hoisted_13)])]), (_order$value13 = order.value) !== null && _order$value13 !== void 0 && _order$value13.usefulDuration ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_order$value14 = order.value) === null || _order$value14 === void 0 ? void 0 : _order$value14.usefulDuration, (date, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: date
        }, [_createElementVNode("span", {
          class: _normalizeClass(['use-date-text-title', index != 0 ? 'hidden' : ''])
        }, "可用日期：", 2), _createTextVNode(_toDisplayString(date), 1)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_hoisted_16, (_order$value15 = order.value) !== null && _order$value15 !== void 0 && _order$value15.quantity ? (_openBlock(), _createElementBlock("div", _hoisted_17, "x " + _toDisplayString((_order$value16 = order.value) === null || _order$value16 === void 0 ? void 0 : _order$value16.quantity), 1)) : _createCommentVNode("", true)]), (order.value.status == 'paid' || order.value.status == 'finished') && (_order$value17 = order.value) !== null && _order$value17 !== void 0 && _order$value17.qrCode ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['ticekt-qrcode-box', order.value.status == 'finished' ? 'is-done' : ''])
      }, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
        class: _normalizeClass(['qrcode-img-modal', order.value.status == 'finished' ? 'is-done' : ''])
      }, [_createElementVNode("img", {
        src: (_order$value18 = order.value) === null || _order$value18 === void 0 ? void 0 : _order$value18.qrCode
      }, null, 8, _hoisted_20)], 2), _hoisted_21])], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, "￥" + _toDisplayString(order.value.priceTotal), 1)]), (_order$value19 = order.value) !== null && _order$value19 !== void 0 && _order$value19.halfPriceStr ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, "￥" + _toDisplayString((_order$value20 = order.value) === null || _order$value20 === void 0 ? void 0 : _order$value20.halfPriceStr), 1)])) : _createCommentVNode("", true), (_order$value21 = order.value) !== null && _order$value21 !== void 0 && _order$value21.proPriceStr ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, "￥" + _toDisplayString((_order$value22 = order.value) === null || _order$value22 === void 0 ? void 0 : _order$value22.proPriceStr), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, "￥" + _toDisplayString(order.value.totalFeeStr), 1)])]), order.value.status == 'pending' ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("span", _hoisted_41, _toDisplayString(order.value.isRedeem ? "兑换" : "订单") + "编号：", 1), _createElementVNode("span", _hoisted_42, _toDisplayString(order.value.objectId), 1)]), _createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("span", _hoisted_45, _toDisplayString(order.value.createAtStr), 1)]), (_order$value23 = order.value) !== null && _order$value23 !== void 0 && _order$value23.payTimeStr ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_hoisted_47, _createElementVNode("span", _hoisted_48, _toDisplayString((_order$value24 = order.value) === null || _order$value24 === void 0 ? void 0 : _order$value24.payTimeStr), 1)])) : _createCommentVNode("", true), (order.value.status == 'paid' || order.value.status == 'finished') && (_order$value25 = order.value) !== null && _order$value25 !== void 0 && _order$value25.transactionId ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_hoisted_50, _createElementVNode("span", _hoisted_51, _toDisplayString((_order$value26 = order.value) === null || _order$value26 === void 0 ? void 0 : _order$value26.objectId), 1)])) : _createCommentVNode("", true), (order.value.status == 'paid' || order.value.status == 'finished') && (_order$value27 = order.value) !== null && _order$value27 !== void 0 && _order$value27.transactionId ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_hoisted_53, _createElementVNode("span", _hoisted_54, _toDisplayString((_order$value28 = order.value) === null || _order$value28 === void 0 ? void 0 : _order$value28.transactionId), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createVNode(_unref(VanDialog), {
        class: "share-img-dialog",
        show: showDialog.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showDialog.value = $event),
        onClose: onCloseShareDialog,
        showConfirmButton: false,
        closeOnClickOverlay: true,
        "lazy-render": false
      }, {
        default: _withCtx(() => [_hoisted_55, _createElementVNode("div", _hoisted_56, [payQrcode.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "share-img",
          src: payQrcode.value
        }, null, 8, _hoisted_57)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["show"]), _createVNode(_unref(VanDialog), {
        class: "pay-error-dialog-two",
        show: showPayErrorDialog.value,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => showPayErrorDialog.value = $event),
        onClose: onClosePayDialog,
        showConfirmButton: false,
        closeOnClickOverlay: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_hoisted_59, _createElementVNode("div", _hoisted_60, [_createVNode(CommonBtn, {
          text: "确认",
          type: "plain",
          width: "120px",
          onHandleClick: closeErrorDialog
        })])])]),
        _: 1
      }, 8, ["show"])], 2), ((_order$value29 = order.value) === null || _order$value29 === void 0 ? void 0 : _order$value29.status) == 'pending' ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, "待付款：￥" + _toDisplayString((_order$value30 = order.value) === null || _order$value30 === void 0 ? void 0 : _order$value30.totalFeeStr), 1), _createElementVNode("div", _hoisted_64, "请在" + _toDisplayString((_order$value31 = order.value) === null || _order$value31 === void 0 ? void 0 : _order$value31.expiresAtStr) + "前完成支付", 1)]), _createVNode(CommonBtn, {
        text: "立即支付",
        width: "132px",
        height: "32px",
        params: order.value,
        onHandleClick: handleBuy
      }, null, 8, ["params"])])) : _createCommentVNode("", true), ((_order$value32 = order.value) === null || _order$value32 === void 0 ? void 0 : _order$value32.status) == 'closed' ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_hoisted_66, _createVNode(CommonBtn, {
        text: "再次购买",
        width: "132px",
        height: "32px",
        onHandleClick: handleBuyMore
      })])) : _createCommentVNode("", true)], 64);
    };
  }

};